'use client';
import { useAuth } from '@/contexts/AuthContext';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import AppLayout from '@/components/AppLayout';
import LiveTrackingContent from './components/LiveTrackingContent';

export default function LiveTrackingPage() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!loading && !user) {
      router?.push('/sign-up-login-screen');
    }
  }, [user, loading, router]);

  if (loading || !user) return null;

  return (
    <AppLayout role="customer">
      <LiveTrackingContent />
    </AppLayout>
  );
}
